
// const headerSectionId1 = 'sections--18102980903025__header_section';
function getHeaderSectionId() {
  return document
    .querySelector('[id^="shopify-section-sections--"][id*="header_section"]')
    ?.id.replace('shopify-section-', '');
}

function fetchSectionHtmlDirect() {
  const headerSectionId = getHeaderSectionId();
// const url = `${window.location.pathname}?section_id=${encodeURIComponent(headerSectionId1)}`;
const url = `/?section_id=${encodeURIComponent(headerSectionId)}`;
return fetch(url, {
    method: 'GET',
    headers: {
    Accept: 'text/html',
    },
}).then((res) => res.text());
}

// document.addEventListener('click', async function (e) {
//   const btn = e.target.closest('.resource-card__add-to-cart-bundle');
//   if (!btn) return;

//   e.preventDefault();
//   btn.disabled = true;

//   // collect all bundle variant ids, qty = 1 each
//   const variantEls = document.querySelectorAll('.bundle-variant-id');
//   const items = Array.from(variantEls)
//     .map(el => el.getAttribute('data-variant-id'))
//     .filter(id => !!id)
//     .map(id => ({ id, quantity: 1 }));

//   if (!items.length) {
//     btn.disabled = false;
//     return;
//   }

//   // add all variants in one call
//   const resp = await fetch('/cart/add.js', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({ items })
//   });

//   if (!resp.ok) {
//     alert('Failed to add to cart');
//     btn.disabled = false;
//     return;
//   }

//   const { CartUpdateEvent } = await import('@theme/events');

//   const cartResp = await fetch('/cart.js');
//   const cart = await cartResp.json();

//   const event = new CartUpdateEvent(cart, 'manual-trigger', {
//     itemCount: cart.item_count,
//     source: 'add-to-cart-grid',
//     sections: {}
//   });
//   document.dispatchEvent(event);

//   await new Promise(resolve => setTimeout(resolve, 450));

//   fetchSectionHtmlDirect().then((html) => {
//     if (!html) return;

//     const temp = document.createElement('div');
//     temp.innerHTML = html;

//     const newSectionRoot =
//       temp.querySelector(`#shopify-section-${headerSectionId1}`) || temp.firstElementChild;
//     if (!newSectionRoot) return;

//     const newDrawerInner = newSectionRoot.querySelector('.cart-drawer__inner');
//     const currentDrawerInner = document.querySelector('.cart-drawer__inner');
//     if (newDrawerInner && currentDrawerInner) {
//       currentDrawerInner.innerHTML = newDrawerInner.innerHTML;

//       const cartDrawerrm = document.querySelector('.cart-drawer__dialog');
//       if (cartDrawerrm) {
//         cartDrawerrm.classList.remove('cart-drawer--empty');
//       }

//       const drawer = document.querySelector('cart-drawer-component');
//       if (drawer?.hasAttribute('auto-open')) {
//         drawer.open();
//       }
//     }

//     const newCartIcon = newSectionRoot.querySelector('.header-actions__cart-icon');
//     const currentCartIcon = document.querySelector('.header-actions__cart-icon');
//     if (newCartIcon && currentCartIcon) {
//       currentCartIcon.innerHTML = newCartIcon.innerHTML;
//     }
//   });

//   btn.disabled = false;
// });

document.addEventListener('click', async function (e) {
  const btn = e.target.closest('.resource-card__add-to-cart-bundle');
  if (!btn) return;

  e.preventDefault();
  btn.disabled = true;

  try {
    // Get UNIQUE variant IDs only (prevents duplicates)
    const allVariantEls = document.querySelectorAll('.bundle-variant-id');
    const uniqueIds = new Set();
    const items = [];

    allVariantEls.forEach(el => {
      const variantId = el.getAttribute('data-variant-id');
      if (variantId && !uniqueIds.has(variantId)) {
        uniqueIds.add(variantId);
        items.push({ id: parseInt(variantId), quantity: 1 });
      }
    });

    console.log(`Adding ${items.length} unique items bundle:`, items);

    if (!items.length) {
      btn.disabled = false;
      return;
    }

    // Add to cart
    const resp = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });

    if (!resp.ok) {
      alert('Failed to add to cart');
      btn.disabled = false;
      return;
    }

    console.log('✓ Items added to cart');

    // Wait for cart to update on server
    await new Promise(resolve => setTimeout(resolve, 300));

    // Get updated cart data
    const cartResp = await fetch('/cart.js');
    const cart = await cartResp.json();
    console.log('✓ Cart now has', cart.item_count, 'items');

    // Update header section (cart drawer + icon)
    // const headerSectionId = 'sections--18102980903025__header_section';
   const headerSectionId = getHeaderSectionId();
    const timestamp = new Date().getTime();
    const url = `/?section_id=${headerSectionId}&t=${timestamp}`;
    
    const htmlResp = await fetch(url, { 
      headers: { 'Accept': 'text/html' } 
    });
    const html = await htmlResp.text();

    if (html) {
      const temp = document.createElement('div');
      const headerSectionId = getHeaderSectionId();
      temp.innerHTML = html;
      
      const newSectionRoot = temp.querySelector(`#shopify-section-${headerSectionId}`) || temp.firstElementChild;

      if (newSectionRoot) {
        // Update cart drawer content
        const newDrawerInner = newSectionRoot.querySelector('.cart-drawer__inner');
        const currentDrawerInner = document.querySelector('.cart-drawer__inner');
        if (newDrawerInner && currentDrawerInner) {
          currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
          console.log('✓ Cart drawer content updated');
        }

        // Update cart icon
        const newCartIcon = newSectionRoot.querySelector('.header-actions__cart-icon');
        const currentCartIcon = document.querySelector('.header-actions__cart-icon');
        
        if (newCartIcon && currentCartIcon) {
          currentCartIcon.innerHTML = newCartIcon.innerHTML;
          console.log('✓ Cart icon updated');
        }

        // Remove empty state
        const cartDrawerDialog = document.querySelector('.cart-drawer__dialog');
        if (cartDrawerDialog) {
          cartDrawerDialog.classList.remove('cart-drawer--empty');
        }
      }
    }

    // Dispatch CartUpdateEvent
    try {
      const { CartUpdateEvent } = await import('@theme/events');
      const event = new CartUpdateEvent(cart, 'manual-trigger', {
        itemCount: cart.item_count,
        source: 'add-to-cart-bundle',
        sections: {}
      });
      document.dispatchEvent(event);
      console.log('✓ CartUpdateEvent dispatched');
    } catch (err) {
      console.log('CartUpdateEvent not available');
    }

    // Wait for DOM updates to complete
    await new Promise(resolve => setTimeout(resolve, 300));

    // Open the cart drawer
    const drawerComponent = document.querySelector('cart-drawer-component');
    
    if (drawerComponent) {
      if (typeof drawerComponent.open === 'function') {
        drawerComponent.open();
        console.log('✓ Cart drawer opened');
      } else {
        drawerComponent.setAttribute('open', '');
        
        const dialog = drawerComponent.querySelector('.cart-drawer__dialog');
        if (dialog) {
          dialog.setAttribute('open', '');
          
          if (dialog.tagName === 'DIALOG' && typeof dialog.showModal === 'function') {
            dialog.showModal();
          }
        }
        console.log('✓ Cart drawer opened (manual)');
      }
    } else {
      console.error('❌ cart-drawer-component not found');
    }

  } catch (error) {
    console.error('❌ Error:', error);
    alert('An error occurred. Please try again.');
  } finally {
    btn.disabled = false;
  }
});



// function removeProducts(lineItemKey) {
//   alert("bundle-add-to-cart")
//   // lineItemKey should be passed from the clicked remove button
//   if (!lineItemKey) {
//     console.error('No line item key provided');
//     return;
//   }

//   const updates = {
//     [lineItemKey]: 0, // Remove ONLY the clicked line item
//   };

//   return fetch('/cart/update.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//       'Accept': 'application/json',
//     },
//     body: JSON.stringify({ updates }),
//   })
//     .then((res) => res.json())
//     .then((cart) => {
//       fetchSectionHtmlDirect().then((html) => {
//         if (!html) return;

//         const temp = document.createElement('div');
//         temp.innerHTML = html;

//         const newSectionRoot =
//           temp.querySelector(`#shopify-section-${headerSectionId1}`) ||
//           temp.firstElementChild;
//         if (!newSectionRoot) return;

//         const newDrawerInner =
//           newSectionRoot.querySelector('.cart-drawer__inner');
//         const currentDrawerInner =
//           document.querySelector('.cart-drawer__inner');
//         if (newDrawerInner && currentDrawerInner) {
//           currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
//         }

//         const newCartIcon =
//           newSectionRoot.querySelector('.header-actions__cart-icon');
//         const currentCartIcon =
//           document.querySelector('.header-actions__cart-icon');
//         if (newCartIcon && currentCartIcon) {
//           currentCartIcon.innerHTML = newCartIcon.innerHTML;
//         }
//       });
//     })
//     .catch((err) => {
//       console.error('Failed to remove clicked item from cart', err);
//     });
// }
function removeProducts(lineItemKey) {

  if (!lineItemKey) {
    console.error('No line item key provided');
    return;
  }

  const updates = {
    [lineItemKey]: 0
  };

  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    body: JSON.stringify({ updates }),
  })
  .then((res) => res.json())
  .then(() => {

    fetchSectionHtmlDirect().then((html) => {
      if (!html) return;

      const temp = document.createElement('div');
      temp.innerHTML = html;

      const headerSectionId = getHeaderSectionId();

      const newSectionRoot =
        temp.querySelector(`#shopify-section-${headerSectionId}`);

      if (!newSectionRoot) return;

      const newDrawerInner = newSectionRoot.querySelector('.cart-drawer__inner');
      const currentDrawerInner = document.querySelector('.cart-drawer__inner');

      if (newDrawerInner && currentDrawerInner) {
        currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
      }

      const newCartIcon = newSectionRoot.querySelector('.header-actions__cart-icon');
      const currentCartIcon = document.querySelector('.header-actions__cart-icon');

      if (newCartIcon && currentCartIcon) {
        currentCartIcon.innerHTML = newCartIcon.innerHTML;
      }

    });

  })
  .catch((err) => {
    console.error('Failed to remove item from cart', err);
  });
}
function updateCartQuantity(lineItemKey, newQuantity) {
  if (!lineItemKey || newQuantity === undefined) {
    console.error('Missing lineItemKey or newQuantity');
    return;
  }

  const updates = {
    [lineItemKey]: newQuantity
  };

  return fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    body: JSON.stringify({ updates }),
  })
    .then((res) => res.json())
    .then((cart) => {
      // Update UI after successful quantity update
      fetchSectionHtmlDirect().then((html) => {
        if (!html) return;

        const temp = document.createElement('div');
        temp.innerHTML = html;
        const headerSectionId = getHeaderSectionId();
        const newSectionRoot =
          temp.querySelector(`#shopify-section-${headerSectionId}`) ||
          temp.firstElementChild;
        if (!newSectionRoot) return;

        const newDrawerInner =
          newSectionRoot.querySelector('.cart-drawer__inner');
        const currentDrawerInner =
          document.querySelector('.cart-drawer__inner');
        if (newDrawerInner && currentDrawerInner) {
          currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
        }

        const newCartIcon =
          newSectionRoot.querySelector('.header-actions__cart-icon');
        const currentCartIcon =
          document.querySelector('.header-actions__cart-icon');
        if (newCartIcon && currentCartIcon) {
          currentCartIcon.innerHTML = newCartIcon.innerHTML;
        }
      });
    })
    .catch((err) => {
      console.error('Failed to update cart quantity', err);
    });
}

// Event delegation for all quantity controls
document.addEventListener('click', function(e) {
  // Handle +/- buttons
  const lineItemKey = e.target.closest('[data-line-key]')?.dataset.lineKey;
  const quantityInput = e.target.closest('.quantity-selector-component')?.querySelector('input') ||
                       document.querySelector(`[data-line-key="${lineItemKey}"] input[type="number"]`);

  if (lineItemKey && quantityInput && 
      (e.target.classList.contains('quantity-minus') || e.target.classList.contains('quantity__minus'))) {
    let newQuantity = Math.max(0, parseInt(quantityInput.value));
    quantityInput.value = newQuantity;
    updateCartQuantity(lineItemKey, newQuantity);
  }

  if (lineItemKey && quantityInput && 
      (e.target.classList.contains('quantity-plus') || e.target.classList.contains('quantity__plus'))) {
    let newQuantity = parseInt(quantityInput.value);
    quantityInput.value = newQuantity;
    updateCartQuantity(lineItemKey, newQuantity);
  }
});

// Handle direct input changes (user types new quantity)
document.addEventListener('change', function(e) {
  if (e.target.matches('input[type="number"]') || e.target.classList.contains('quantity-selector-component')) {
    const lineItemKey = e.target.closest('[data-line-key]')?.dataset.lineKey;
    const newQuantity = parseInt(e.target.value) || 0;
    
    if (lineItemKey !== undefined) {
      updateCartQuantity(lineItemKey, newQuantity);
    }
  }
});

// Optional: Handle input on blur/enter for immediate update
document.addEventListener('blur', function(e) {
  if (e.target.matches('input[type="number"]') || e.target.classList.contains('quantity-selector-component')) {
    const lineItemKey = e.target.closest('[data-line-key]')?.dataset.lineKey;
    const newQuantity = parseInt(e.target.value) || 0;
    
    if (lineItemKey !== undefined) {
      updateCartQuantity(lineItemKey, newQuantity);
    }
  }
}, true);
